import type { SVGProps } from 'react';
import { Lightbulb, CircleCheckBig, Dumbbell } from 'lucide-react';

export const INTERSTITIAL_ICON_REGISTRY: Record<string, React.FC<SVGProps<SVGSVGElement>>> = {
  lightbulb: Lightbulb,
  checkmark: CircleCheckBig,
  fitness: Dumbbell,
};
